module.exports = __webpack_public_path__ + "static/media/PM76.77c65d6c.JPG";